import type { SimulationTemplateData } from "./types"

/**
 * Read the `test_case_ids` query param: a comma-separated list that narrows a
 * run prefill to those test cases, as sent by "Resimulate in new run".
 */
export function parseTestCaseIdsParam(
  value: string | string[] | undefined,
): string[] | undefined {
  const raw = Array.isArray(value) ? value.join(",") : value
  const ids = [
    ...new Set(
      (raw ?? "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean),
    ),
  ]
  return ids.length > 0 ? ids : undefined
}

/** Restrict a run prefill to the given test cases, dropping any sub-sampling. */
export function applyTestCaseIdsOverride(
  templateData: SimulationTemplateData,
  testCaseIds: string[] | undefined,
): SimulationTemplateData {
  if (!testCaseIds) {
    return templateData
  }
  return {
    ...templateData,
    selectedTestCaseIds: testCaseIds,
    shouldSubSample: false,
    subSampleSize: 0,
  }
}
